var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#81BB27;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#3D3C44;}\r\n\t.st3{fill:url(#SVGID_00000018950291477204029710000011359027175505257884_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,11c-0.6,0-1-0.4-1-1V7c0-2.2-1.8-4-4-4S8,4.8,8,7v3c0,0.6-0.4,1-1,1s-1-0.4-1-1V7c0-3.3,2.7-6,6-6 s6,2.7,6,6v3C18,10.6,17.6,11,17,11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 13.305,
    x2: 12,
    y2: 0.8891,
    gradientTransform: "matrix(1 0 0 -1 0 23.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAB17"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,10.5h12c1.7,0,3,1.2,3,2.7v7.1c0,1.5-1.3,2.7-3,2.7H6c-1.7,0-3-1.2-3-2.7v-7.1C3,11.7,4.3,10.5,6,10.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12,20c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1s1,0.4,1,1v3C13,19.6,12.6,20,12,20z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094593742343870459560000000059029768740188816_",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 10.975,
    x2: 12,
    y2: 6.794,
    gradientTransform: "matrix(1 0 0 -1 0 23.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D5C66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48474F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000094593742343870459560000000059029768740188816_)"
    },
    cx: 12,
    cy: 15,
    r: 2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock2.ce25ce40216b3758c7ae23abfad2bdc6.svg";
export { ForwardRef as ReactComponent };